import { render, staticRenderFns } from "./TSRKits.vue?vue&type=template&id=a4fbe416"
import script from "./TSRKits.vue?vue&type=script&lang=js"
export * from "./TSRKits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports